import contents from './contents.reducer';


const reducer = contents;
export default reducer;
